import React from 'react'
import DashboardComponent from '../components/DashboardComponent'
import Layout from '../Layout'

function OverviewContainer() {
  return (
    <Layout>
      <DashboardComponent />
    </Layout>
  )
}

export default OverviewContainer
